import React from 'react';
import { Marker as MapGlMarker } from 'react-map-gl/maplibre';
import { clsx } from 'clsx';

import type { MapMarker } from '../types.js';

import { frontendConfig } from '../../../../../../core/system/config/frontend.server.js';

type TopListMapMarkerProps = {
  marker: MapMarker;
  active: boolean;
  onClick: (articleId: string) => void;
};

const { cdnUrlInternal } = frontendConfig;

const TopListMapMarker: React.FC<TopListMapMarkerProps> = ({
  marker,
  active,
  onClick,
}) => {
  const { articleId, location, name } = marker;
  const state = active ? 'active' : 'inactive';

  return (
    <MapGlMarker
      className={`top-list__map-marker top-list__map-marker--${state}`}
      latitude={location.latitude}
      longitude={location.longitude}
      onClick={() => onClick(articleId)}
    >
      <img
        src={`${cdnUrlInternal}/vink/images/icons/map_marker_${state}.svg`}
        className={clsx(
          'top-list__map-marker-icon',
          `top-list__map-marker-icon--${state}`,
        )}
        alt={name}
      />
    </MapGlMarker>
  );
};

export { TopListMapMarker };
